import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten, timestampToDateForInput } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdCheck, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function ExamCycleCreationForm({ data, classroomUuid, streamUuid, callback}) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [title, setTitle] = useState("");
	const [dateStartString, setDateStartString] = useState("");
	const [dateEndString, setDateEndString] = useState("");
	const [applicableSubjects, setApplicableSubjects] = useState([]);

	const [availableSubjects, setAvailableSubjects] = useState([]);


	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getAvailableSubjects(),
		])
		setReady(true);
	}

	function resetForm() {
		setTitle("");
		setDateStartString("");
		setDateEndString("");
		setApplicableSubjects([]);
	}

	function addSubject() {
		setApplicableSubjects(_prev => {
			const _new = [..._prev];

			_new.push("");

			return _new;
		})
	}

	function handleSubjectChange(index, value) {
		setApplicableSubjects(_prev => {
			const _new = [..._prev];

			_new[index] = value;

			return _new;
		})
	}

	function deleteSubject(index) {
		setApplicableSubjects(_prev => {
			const _new = [..._prev];

			_new.splice(index, 1);

			return _new;
		})
	}

	function cleanSubjects(_subjects) {
		const _cleaned = [... new Set(_subjects.filter((item, i) => {
			if(String(item).trim().length > 0) {
				return true;
			} else {
				return false;
			}
		}))]

		return _cleaned;
	}

	async function getAvailableSubjects() {
		if(classroomUuid && streamUuid) {
			await callApi(
				'get-stream-data', 
				{
					uuid: streamUuid,
				}
			).then((response) => {
				if(response.status === 1) {
					setAvailableSubjects(response.data.supportedSubjectsData);
				}
			})
		} else if(classroomUuid && !streamUuid) {
			await callApi(
				'get-classroom-data', 
				{
					uuid: classroomUuid,
				}
			).then((response) => {
				if(response.status === 1) {
					setAvailableSubjects(response.data.supportedSubjectsData);
				}
			})
		}
	}

	async function create() {
		const _subjects = cleanSubjects(applicableSubjects);

		if(title.trim().length > 0) {
			if(dateStartString.trim().length > 0) {
				if(dateEndString.trim().length > 0) {
					if(_subjects.length > 0) {
						setLoading(true);
						await callApi(
							"create-exam-cycle",
							{
								title,
								dateStartString,
								dateEndString,
								classroomUuid: (classroomUuid || ""),
								streamUuid: (streamUuid || ""),
								applicableSubjects: JSON.stringify(_subjects),
								schoolUuid: appContext.currentSchoolUuid,
							}
						).then(response => {
							if(response.status === 1) {
								appContext.tellMessage("Successful");
								resetForm();

								if(callback) {
									callback();
								}
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError("Invalid subjects");
					}
				} else {
					appContext.tellError("Invalid end date");
				}
			} else {
				appContext.tellError("Invalid start date");
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	async function edit() {
		const _subjects = cleanSubjects(applicableSubjects);

		if(title.trim().length > 0) {
			if(dateStartString.trim().length > 0) {
				if(dateEndString.trim().length > 0) {
					if(_subjects.length > 0) {
						setLoading(true);
						await callApi(
							"edit-exam-cycle",
							{
								uuid: data.uuid,
								title,
								dateStartString,
								dateEndString,
								classroomUuid: (classroomUuid || ""),
								streamUuid: (streamUuid || ""),
								applicableSubjects: JSON.stringify(_subjects),
								schoolUuid: appContext.currentSchoolUuid,
							}
						).then(response => {
							if(response.status === 1) {
								appContext.tellMessage("Successful");

								if(callback) {
									callback();
								}
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError("Invalid subjects");
					}
				} else {
					appContext.tellError("Invalid end date");
				}
			} else {
				appContext.tellError("Invalid start date");
			}
		} else {
			appContext.tellError("Invalid title");
		}
	}

	useEffect(() => {
		if(data) {
			setTitle(data.title);
			setDateStartString(timestampToDateForInput(data.dateStart));
			setDateEndString(timestampToDateForInput(data.dateEnd));
			setApplicableSubjects(JSON.parse(data.applicableSubjects));
		}
	}, [ data ])

	useEffect(() => {
		init();
	}, [classroomUuid, streamUuid, data])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Title for this Exam Cycle</label>
					<input
						className="form-control"
						value={title}
						onChange={e => setTitle(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Start Date</label>
					<input
						className="form-control"
						value={dateStartString}
						onChange={e => setDateStartString(e.target.value)}
						type="date"
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">End Date</label>
					<input
						className="form-control"
						value={dateEndString}
						onChange={e => setDateEndString(e.target.value)}
						type="date"
					/>
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Applicable Subjects</label>
					{
						applicableSubjects.map((item, i) => {
							return (
								<div className="d-flex m-1" key={i}>
									<select
										className="form-control"
										
										style={{
											flexGrow: 1,
										}}
										onChange={(e) => handleSubjectChange(i, e.target.value)}
										value={item}
									>
										<option value="">Click to select subject</option>
										{
											availableSubjects.map((item, i) => {
												return (
													<option key={i} value={item.uuid}>{item.name}</option>
												)
											})
										}
									</select>

									<MdDelete
										style={{
											flexShrink: 0,
											cursor: 'pointer'
										}}
										size={24}
										onClick={() => deleteSubject(i)}
										className="text-danger"
									/>
								</div>
							)
						})
					}

					<div className="mt-2">
						<button
							className="btn btn-sm btn-outline-dark"
							onClick={addSubject}
						>
							Add Subject
						</button>
					</div>
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							if(data) {
								if(data.status === 'open') {
									appContext.activateDialog({
										message: `Edit this exam cycle?`,
										onConfirm: edit,
									});
								} else {
									appContext.tellError("Exam Cycle is not open, cannot be edited");
								}
							} else {
								appContext.activateDialog({
									message: `Create new exam cycle, "${title}"?`,
									onConfirm: create,
								});
							}
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}